import React from 'react';
import { useState, useEffect, Fragment } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { configData } from "../../../../../src/config/systemconfigurationconstants";
import * as AWS from 'aws-sdk';
import { ToastContainer, toast } from "react-toastify";
import { useEncryption } from '../../../../customHooks/useEncryption';
const ruleTypeLabels = {
    1: "Base",
    2: "Client-Specific",
    3: "Client-Exclusive",
    4: "Income Rule",
    5: "Rule Condition", // fallback
};
const ConfigureRuleSetSave = ({ show, handleClose, modifiedversionjson, usecase, client, configiuidata, handleclosesavepopup, getconfigRulesetManagement, handleenabledotloader }) => {
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const sortedData = [...modifiedversionjson].sort((a, b) => a.RuleTypeId - b.RuleTypeId);
    const [applyImmediately, setApplyImmediately] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    // const handleSave = () => {
    //     const payload = {
    //         applyImmediately,
    //         startDate,
    //         endDate,
    //     };
    //     console.log("Saving with payload:", payload);
    //     handleClose(); // Close the modal after saving
    // };
    const handleSave = async () => {
        handleenabledotloader();
        setApplyImmediately(false);
        setStartDate(null);
        setEndDate(null);
        handleclosesavepopup();
        let saveconfigjson = {
            applyImmediately: applyImmediately,
            startDate: startDate,
            endDate: endDate,
            UseCaseId: usecase,
            ClientId: client,
            UserName: localStorage.getItem("UserName").trim(),
            VersionInfoId: modifiedversionjson.map(({ ExcelRuleVersionInfoId, IdxVersionInfoId, RuleTypeId }) => ({
                ExcelRuleVersionInfoId,
                IdxVersionInfoId,
                RuleTypeId
            }))
        }
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });

        const payloadData = {
            Command: configData.SAVE_EXCEL_RULE_VERSION_CONFIG,
            SecurityId: "",
            ConfigJSON: saveconfigjson,
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: ""
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(payloadData)
        };
        try {
            // Wrap lambda.invoke in a Promise to use await
            const lambdaResponse = await new Promise((resolve, reject) => {
                lambda.invoke(params, (err, data) => {
                    if (err) reject(err);
                    else resolve(data);
                });
            });

            const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
            if (parsedPayload.statusCode === 200) {
                const parsedBody = JSON.parse(parsedPayload.body);
                const parsedoutput = JSON.parse(parsedBody.Output)
                console.log(JSON.parse(parsedBody.Output))
                idxSaveRuleConfiguration();
            }
            else {
                // setDotLoader(false);
                toast.error("Rule Changes saved Failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                await getconfigRulesetManagement();
            }
        } catch (error) {
            // setDotLoader(false);
            console.error('Rule Changes savedFailed', error);
            toast.error("Rule Upload Failed", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            await getconfigRulesetManagement();
        }

    }
    const idxSaveRuleConfiguration = async () => {
        let saveconfigjson = {
            applyImmediately: applyImmediately,
            startDate: startDate,
            endDate: endDate,
            UseCaseId: configiuidata.IDXUCSN,
            ClientId: configiuidata.IDXCSN,
            UserName: localStorage.getItem("UserName").trim(),
            VersionInfoId: modifiedversionjson.map(({ ExcelRuleVersionInfoId, IdxVersionInfoId, RuleTypeId }) => ({
                ExcelRuleVersionInfoId,
                IdxVersionInfoId,
                RuleTypeId
            }))
        }
        const lambda = new AWS.Lambda({
            region: configData.LAMBDA_REGION,
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk')),
            // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
            httpOptions: {
                timeout: 180000
            }
        });
        // Disable SDK-level retries for all AWS services
        AWS.config.update({
            maxRetries: 0
        });

        const payloadData = {
            Command: configData.ENABLE_RPM_FOR_SELECTED_VERSION,
            SecurityId: "",
            ConfigJSON: saveconfigjson,
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: ""
        };

        const params = {
            FunctionName: 'GDXUIWrapper',
            Payload: JSON.stringify(payloadData)
        };
        try {
            // Wrap lambda.invoke in a Promise to use await
            const lambdaResponse = await new Promise((resolve, reject) => {
                lambda.invoke(params, (err, data) => {
                    if (err) reject(err);
                    else resolve(data);
                });
            });

            const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
            if (parsedPayload.statusCode === 200) {
                const parsedBody = JSON.parse(parsedPayload.body);
                const parsedoutput = JSON.parse(parsedBody.Output)
                console.log(JSON.parse(parsedBody.Output))
                toast.success("Rule Changes saved successfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                await getconfigRulesetManagement();

            }
            else {
                // setDotLoader(false);
                toast.error("Rule Changes saved Failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                await getconfigRulesetManagement();

            }
        } catch (error) {
            // setDotLoader(false);
            console.error('Error in getCurrentRpm:', error);
            toast.error("Rule Changes saved Failed", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            await getconfigRulesetManagement();

        }

    }
    const handlecancelpopup = () => {
        handleclosesavepopup();
        setApplyImmediately(false);
        setStartDate(null);
        setEndDate(null);

    }
    return (
        <Modal show={show} onHide={handlecancelpopup}>
            <Modal.Header closeButton>
                <Modal.Title>Save</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* `V${info.VersionId} ${info.CreatedOnUTC} ${info.UserName}` */}
                <p>Your New Version is</p>
                {sortedData.map((info, idx) => {
                    const label = ruleTypeLabels[info.RuleTypeId] || `RuleTypeId-${info.RuleTypeId}`;
                    const versionText =
                        info.ExcelRuleVersionInfoId === null
                            ? "none"
                            : `V${info.VersionId} ${info.CreatedOnUTC} ${info.UserName}`;
                    return <p key={idx}>{label}: {versionText}</p>;
                })}

                <Form>
                    <Form.Group as={Row} className="mb-3" controlId="applyImmediately">
                        <Col sm="4" className='pe-0'>
                            <Form.Check
                                type="checkbox"
                                label="Apply Immediately (or)"
                                checked={applyImmediately}
                                onChange={(e) => setApplyImmediately(e.target.checked)}
                                disabled={startDate !== null && endDate !== null}
                            />
                        </Col>
                        <Col sm="8">
                            <Row>
                                <Col sm={6}>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        showIcon
                                        isClearable
                                        placeholderText="Start Date"
                                        className="form-control"
                                        minDate={new Date()}
                                        disabled={applyImmediately}
                                    />
                                </Col>
                                <Col sm={6}>
                                    <DatePicker
                                        selected={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        showIcon
                                        isClearable
                                        placeholderText="End Date"
                                        className="form-control"
                                        minDate={new Date()}
                                        disabled={applyImmediately}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size='sm' onClick={handlecancelpopup}>
                    Close
                </Button>
                <Button variant="primary" size='sm' onClick={handleSave} disabled={!(applyImmediately || (startDate !== null && endDate !== null))}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfigureRuleSetSave;